import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './argus.css'
import './argus-layers.css'
import './argus-marketing.css'
import './argus-role-layers.css'
import './argus-onboarding.css'
import './argus-auth.css'
import './argus-tiles.css'
import './argus-profile-tiles.css'
import './argus-athlete-fixes.css'
import './argus-insignia.css'
import './argus-content-rhythm.css'
import './argus-mobile-nav.css'
import './argus-beta-lock.css'
import './argus-workspace-beta-lock.css'
import './argus-experience-beta-lock.css'
import './argus-presentability-lock.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
